"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlappingCard = exports.OverlappingCardRatioOptions = void 0;
var React = require("react");
var OverlappingCard_st_css_1 = require("./OverlappingCard.st.css");
var Card_1 = require("../Card");
Object.defineProperty(exports, "OverlappingCardRatioOptions", { enumerable: true, get: function () { return Card_1.CardRatioOptions; } });
var deprecationLog_1 = require("../../common/deprecationLog");
var OverlappingCard = function (_a) {
    var info = _a.info, media = _a.media, ratio = _a.ratio, invertInfoPosition = _a.invertInfoPosition, flippedRatio = _a.flippedRatio, className = _a.className, dataHook = _a["data-hook"];
    deprecationLog_1.deprecationLog('OverlappingCard', 'The current `Card` component API will be deprecated in the next major version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--newcard');
    return (React.createElement("div", { className: OverlappingCard_st_css_1.st(OverlappingCard_st_css_1.classes.root, {
            ratio: media ? ratio : Card_1.CardRatioOptions.RATIO_100,
            invertInfoPosition: invertInfoPosition,
            flippedRatio: flippedRatio,
        }, className), "data-hook": dataHook },
        media && ratio !== Card_1.CardRatioOptions.RATIO_100 && (React.createElement("div", { className: OverlappingCard_st_css_1.classes.mediaContainer }, media)),
        info && React.createElement("div", { className: OverlappingCard_st_css_1.classes.infoContainer }, info)));
};
exports.OverlappingCard = OverlappingCard;
OverlappingCard.displayName = 'OverlappingCard';
OverlappingCard.MIN_WIDTH = 700;
OverlappingCard.defaultProps = {
    ratio: Card_1.CardRatioOptions.RATIO_50_50,
    flippedRatio: false,
    invertInfoPosition: false,
};
//# sourceMappingURL=OverlappingCard.js.map